import api from './api';

const connectorService = {
  getAllConnectors: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.hotelid) params.append('hotelid', filters.hotelid);
    if (filters.accountid) params.append('accountid', filters.accountid);
    if (filters.connectorType) params.append('connectorType', filters.connectorType);
    if (filters.connectorStatus) params.append('connectorStatus', filters.connectorStatus);
    if (filters.environment) params.append('environment', filters.environment);
    if (filters.search) params.append('search', filters.search);
    if (filters.limit) params.append('limit', filters.limit);

    const response = await api.get(`/connectors${params.toString() ? '?' + params.toString() : ''}`);
    return response.data;
  },

  getConnectorById: async (id, hotelid = null) => {
    const params = new URLSearchParams();
    if (hotelid) params.append('hotelid', hotelid);
    const response = await api.get(`/connectors/${id}${params.toString() ? '?' + params.toString() : ''}`);
    return response.data;
  },

  createConnector: async (connectorData) => {
    // Clean up data: convert empty strings to null for optional fields
    const cleanedData = {
      ...connectorData,
      connectorUsername: connectorData.connectorUsername || null,
      connectorHost: connectorData.connectorHost || null,
      connectorPort: connectorData.connectorPort || null,
      connectorPassword: connectorData.connectorPassword || null,
      connectorDBName: connectorData.connectorDBName || null,
      sftpfrequency: connectorData.sftpfrequency || null,
      sftpfolder: connectorData.sftpfolder || null,
      sftpdeletefile: connectorData.sftpdeletefile || null,
      connectorDescription: connectorData.connectorDescription || null,
      version: connectorData.version || null,
      region: connectorData.region || null
    };
    console.log('Creating connector with data:', cleanedData);
    const response = await api.post('/connectors', cleanedData);
    return response.data;
  },

  updateConnector: async (id, connectorData) => {
    const response = await api.put(`/connectors/${id}`, connectorData);
    return response.data;
  },

  deleteConnector: async (id, hotelid = null) => {
    const params = new URLSearchParams();
    if (hotelid) params.append('hotelid', hotelid);
    const response = await api.delete(`/connectors/${id}${params.toString() ? '?' + params.toString() : ''}`);
    return response.data;
  }
};

export default connectorService;
